import { useState } from 'react';

const useModal = () => {
  const [openModal, setOpenModal] = useState(false);
  const [modalInfo, setModalInfo] = useState();

  return { openModal, setOpenModal, setModalInfo, modalInfo };
};

export default useModal;
